module.exports = __webpack_public_path__ + "img/zone_contact_02.965e2301.png";